/* Session page log pop-ups (Replacement / Status / Reschedule) "Download CSV": pure column maps. */
import { reschedule_log_view } from '../../../util_components/care_request/who_asked_rules';
import { format_sub_status } from './session_logs_rules';

// The pop-ups show '--' for a missing value; the CSV leaves the cell empty.
const blank = (v) => (v === undefined || v === null || v === '--' ? '' : v);

// Rows are the unified replacement rows the pop-up builds (app + manual logs).
export const REPLACEMENT_LOG_CSV_COLUMNS = [
  { header: 'Mode', value: (l) => blank(l.mode) },
  { header: 'Status', value: (l) => blank(l.status) },
  { header: 'From teacher', value: (l) => blank(l.fromTeacherName) },
  { header: 'From teacher UUID', value: (l) => blank(l.fromTeacherUuid) },
  { header: 'To teacher', value: (l) => blank(l.toTeacherName) },
  { header: 'To teacher UUID', value: (l) => blank(l.toTeacherUuid) },
  { header: 'Time (IST)', value: (l) => l.time, kind: 'datetime' },
  { header: 'Done by', value: (l) => blank(l.doneBy) },
  { header: 'Notes', value: (l) => blank(l.notes) }
];

export const STATUS_HISTORY_CSV_COLUMNS = [
  { header: 'Status', value: (l) => blank(l.status) },
  { header: 'Sub status', value: (l) => blank(format_sub_status(l.sub_status)) },
  { header: 'Changed by', value: (l) => blank(l.changed_by) },
  { header: 'Changed by name', value: (l) => blank(l.actor_name || l.changed_by) },
  { header: 'Date/time (IST)', value: (l) => l.created_date, kind: 'datetime' }
];

export const RESCHEDULE_LOG_CSV_COLUMNS = [
  { header: 'Original time (IST)', value: (l) => l.original_session_time, kind: 'datetime' },
  { header: 'New time (IST)', value: (l) => l.current_session_time, kind: 'datetime' },
  { header: 'Action time (IST)', value: (l) => l.created_date, kind: 'datetime' },
  { header: 'Changed for', value: (l) => blank(reschedule_log_view(l).shown) },
  { header: 'Who asked status', value: (l) => reschedule_log_view(l).marker_text },
  { header: 'Who asked detail', value: (l) => reschedule_log_view(l).detail },
  { header: 'Changed by type', value: (l) => blank(l.requester_type) },
  { header: 'Changed by', value: (l) => blank(l.requester_name) },
  { header: 'Changed by UUID', value: (l) => blank(l.requester_uuid) },
  { header: 'Reason', value: (l) => blank(l.reason_for_reschedule) }
];
